export type LessonSelection = {
  topicVtwIds: string[];
  questionVtwIds: string[];
};

export enum LessonSelectionError {
  NO_TOPIC_SELECTED = 'NO_TOPIC_SELECTED',
  NO_QUESTION_SELECTED = 'NO_QUESTION_SELECTED',
}
